import { render, staticRenderFns } from "./morePds.vue?vue&type=template&id=4ff86222&scoped=true"
import script from "./morePds.vue?vue&type=script&lang=js"
export * from "./morePds.vue?vue&type=script&lang=js"
import style0 from "./morePds.vue?vue&type=style&index=0&id=4ff86222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff86222",
  null
  
)

export default component.exports